import type { z } from 'zod';

/**
 * Validates raw content data against its Zod schema and returns the typed
 * result. Throws on mismatch — content must fail loud, not render silently
 * broken (a malformed edit, or a future CMS payload that doesn't match this
 * contract, must not reach a component).
 */
export function defineContent<T>(schema: z.ZodType<T>, data: unknown): T {
  return schema.parse(data);
}
